export const LoaderDelay = 800;
